// extracted by mini-css-extract-plugin
module.exports = {"head":"e_KM","heading":"e_LM","headLink":"e_MM","intro":"e_NM"};